export default __webpack_public_path__ + "static/media/Cudgel of the Earth Mother.95f7053e.jpg";